/**
 * Client-safe Parent/Child Session tier price helper — plan 84.
 *
 * The Services card and CartTray quantity selectors call this to render
 * a live price as the user picks 1–4 children. The number itself comes
 * back from a single source of truth — this file mirrors the server's
 * `PARENT_CHILD_TIER_CENTS` lookup table verbatim.
 *
 * Important: the BROWSER price is for display only. The server
 * recomputes the actual charge from `child_count` on every checkout
 * call (`src/server/services/pricing.service.ts`). If the two ever
 * disagree, the server number wins; treat any drift here as a bug.
 */
export const PARENT_CHILD_TIER_CENTS = [17000, 25000, 30600, 34500] as const;

/**
 * Cents-denominated tier price. Inputs outside [1, 4] clamp to the
 * closest tier; the UI prevents that case via the 1–4 pill buttons but
 * we guard here so a stale persisted cart value can't crash the render.
 */
export function parentChildPrice(childCount: number): number {
  const n = Math.max(1, Math.min(4, Math.floor(childCount)));
  return PARENT_CHILD_TIER_CENTS[n - 1]!;
}
